import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NewSilentUnitsCountService } from 'src/app/services/newSilentUnitsCount/newSilentUnitsCount.service';

@Component({
    selector: 'app-newSilentUnitsCount-card',
    templateUrl: './newSilentUnitsCount-card.component.html',
    styleUrls: ['./newSilentUnitsCount-card.component.scss'],
})
export class NewSilentUnitsCountCardComponent implements OnInit {

    newSilentUnitsCount$ = new BehaviorSubject<string | undefined>(undefined);

    constructor(
        private _newSilentUnitsCountService: NewSilentUnitsCountService
    ) {

    }

    ngOnInit() {
        this._newSilentUnitsCountService.getTankData$("7").subscribe(result => {
            this.newSilentUnitsCount$.next(result.scalar);
        });
    }
}
